import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What is the difference between Karate and Taekwondo?',
  answer: 'While both are excellent martial arts, Karate (from Japan) generally focuses more on hand strikes, while Taekwondo (from Korea) is famous for its dynamic, fast, and powerful kicking techniques. Both teach the same core values of respect, discipline, and focus.'
}, {
  question: 'What age can my child start?',
  answer: 'We accept students as young as 3 years old in our Mini Troopers program. Our standard Kids classes start at age 6.'
}, {
  question: 'Does my child need experience?',
  answer: 'Not at all! The vast majority of our new students have no prior martial arts experience.'
}];
export function KidsKarateFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-2041" />;
}